import { graphql, Link, StaticQuery } from 'gatsby';
import React from 'react';
import Container from '../../../atoms/Container/Container';
import Icon from '../../../atoms/Icon/Icon';
import Accordion from '../../../molecules/AccordionAlt/Accordion';
import Button from '../../../atoms/Button/Button';
import { Input, useMediaQuery, Button as CButton, useToast, Image } from '@chakra-ui/react';
import { subscribeNewsletter } from 'helpers/customerio'; // Update import to the new Customer.io helper
import { useForm } from '@mantine/form';
import useSegment from 'hooks/useSegment';
import * as styles from './Footer.module.scss';

const Footer = (props) => {
  const toast = useToast();
  const { track, identifyManual } = useSegment();
  const config = props.config?.data?.footer;
  const [isPc] = useMediaQuery('(min-width: 800px)', {
    ssr: true,
    fallback: false
  });

  const form = useForm({
    initialValues: {
      email: '',
      loading: false
    }
  });

  const subscribeHandler = async (e) => {
    e.preventDefault();
    const thisData = { email: form.values.email };

    identifyManual({ email: form.values.email });
    track('Subscribed to Newsletter', {
      email: form.values.email
    });
    form.setFieldValue('loading', true);
    subscribeNewsletter(thisData)
      .then((response) => {
        if (response && response.status === 0) {
          toast({
            position: 'top-right',
            title: 'Subscribed',
            colorScheme: 'primary',
            description: 'You have successfully subscribed to our newsletter.',
            status: 'success'
          });
          form.reset();
        } else {
          toast({
            colorScheme: 'secondary',
            title: 'Subscription failed',
            description: 'Please try again later.',
            status: 'error',
            position: 'top-right'
          });
        }
      })
      .catch(() => {
        toast({
          colorScheme: 'secondary',
          title: 'Subscription failed',
          description: 'Please try again later.',
          status: 'error',
          position: 'top-right'
        });
      })
      .finally(() => {
        form.setFieldValue('loading', false);
      });
  };

  const renderLinks = (linkCollection) => {
    return (
      <ul>
        {linkCollection.map((link, index) => {
          return (
            <li key={index}>
              <Link
                className={`${styles.link} fancy`}
                to={link.url}
                target={link.newWindow ? '_blank' : '_self'}
              >
                {link.name}
              </Link>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className={styles.root}>
      <div className="subscribe">
        <Container size={'large'} spacing={'min'}>
          <div className="subscribe-title">
            <p>{'JOIN THE CLUB'}</p>
            <h3 className="text-balance">
              {'Sign up for exclusive offers and club-only discounts!'}
            </h3>
          </div>
          <form className="subscribe-action" onSubmit={subscribeHandler}>
            <Input required {...form.getInputProps('email')} type="email" placeholder="Email" />
            <CButton
              isLoading={form.values.loading}
              disabled={form.values.loading}
              type="submit"
              className="primary"
            >
              SUBSCRIBE
            </CButton>
          </form>
        </Container>
      </div>
      <div className="links">
        <Container size={'large'} spacing={'min'}>
          <div className="icon-wrapper">
            {config?.features?.map((feature, index) => (
              <div key={index} className="infographic">
                <Image src={feature?.image} />
                <p>{feature.text}</p>
              </div>
            ))}
            <div className="infographic socials">
              <Link to={'/'} className="cursor-pointer">
                <Icon symbol={'pet'} />
              </Link>
              <ul>
                {config?.socials.map((social, index) => (
                  <li key={index}>
                    <Link to={social.url} className="cursor-pointer" target={'_blank'}>
                      <Icon symbol={social.iconName} />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="contact mobile">
              <Button level={'secondary'} type={'a'} href={config?.contactLink} target={'_blank'}>
                CONTACT US
              </Button>
              {!!config?.footerText && (
                <div dangerouslySetInnerHTML={{ __html: config?.footerText }}></div>
              )}
            </div>
          </div>
          <div className="links-wrapper">
            {config?.linksLists?.map((linksList, index) => (
              <Accordion
                hideIcon
                key={index}
                customStyle={styles}
                type={'caret'}
                title={linksList.header}
                defaultOpen={isPc}
              >
                <div>{renderLinks(linksList.links)}</div>
              </Accordion>
            ))}
            <div className="contact">
              <Button level={'secondary'} target={'_blank'} type={'a'} href={config?.contactLink}>
                CONTACT US
              </Button>
              {!!config?.footerText && (
                <div dangerouslySetInnerHTML={{ __html: config?.footerText }}></div>
              )}
            </div>
          </div>
        </Container>
        <Container size={'large'} spacing={'min'}>
          <div className="copyright">
            ©{new Date().getFullYear()} Pet Chemist Online all rights reserved.
          </div>
        </Container>
      </div>
    </div>
  );
};

export default function BuilderFooter(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          allBuilderModels {
            config: oneConfig(query: { name: "Configuration" }) {
              data {
                footer
              }
            }
          }
        }
      `}
      render={(data) => <Footer {...data.allBuilderModels} {...props} />}
    />
  );
}
